module.exports = __webpack_public_path__ + "static/logo.ea46cbfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logo.png
// module id = 457
// module chunks = 35783957827783